import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ProjectsList from './components/ProjectsList';
import ProjectView from './components/ProjectView';
import Login from './components/Login';
import UnauthorizedPage from './components/UnauthorizedPage';
import CallbackPage from './components/CallbackPage';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/projects/new" element={<ProjectView />} />
        <Route path="/projects/:projectId" element={<ProjectView />} />
        <Route path="/" element={<ProjectsList />} />
        <Route path="/unauthorized" element={<UnauthorizedPage />} />
        <Route path="/callback/:linkId" element={<CallbackPage />} />
      </Routes>
    </Router>
  );
};

export default App;